import { PageContainer } from './page-container';

/**
 * The route-level loading shell every `loading.tsx` renders. Next streams it
 * as soon as the root layout resolves, so a slow page segment — or a slow
 * connection — shows the page's shape instead of an empty document.
 *
 * Deliberately without AppShell. The SIP registration itself is safe either
 * way — useSoftphone is mounted by SoftphoneRuntimeProvider in the root
 * layout, which outlives every loading state — but the shell owns the phone's
 * UI (widget, dock), the hot-transfer stream and the skew watcher, and a
 * Suspense fallback is unmounted the moment the page arrives, so mounting it
 * here would churn all of that on every navigation.
 *
 * That cuts the other way too, and is why routes reached by an automatic
 * navigation get no loading.tsx at all: without one Next keeps the OLD page,
 * dock and call controls included, until the next segment is ready. See the
 * route-group split under contacts/ and campaigns/.
 *
 * One shape for every route: a placeholder promises nothing about the content.
 */
export function PageSkeleton() {
  return (
    <PageContainer>
      <div role="status" aria-label="Loading">
        <div className="corner-brand-xs mb-5 h-5 w-40 animate-pulse bg-white/5" />
        <div className="corner-brand border border-zinc-800 bg-zinc-900">
          {Array.from({ length: 8 }, (_, i) => (
            <div
              key={i}
              className="flex items-center gap-4 border-b border-zinc-800/70 px-3 py-2.5 last:border-b-0"
            >
              <div className="corner-brand-xs h-3 w-1/4 animate-pulse bg-white/5" />
              <div className="corner-brand-xs h-3 w-1/3 animate-pulse bg-white/5" />
              <div className="corner-brand-xs h-3 w-1/6 animate-pulse bg-white/5" />
            </div>
          ))}
        </div>
      </div>
    </PageContainer>
  );
}
